export default "__VITE_ASSET__CXng$eYS__"